import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.css";
import Spinner from "react-bootstrap/Spinner";
import { useSelector, useDispatch } from "react-redux";
import {
  deleteZoomRecording,
  downloadAllZoomRecordings,
} from "../../redux/actions/meetingActions/MeetingAction";
import { formatDateTimeFormat, onlyTime } from "../../helpers/commonHelpers";

import ConfirmModal from "./ConfirmModal";

const ViewZoomRecordings = React.memo((props) => {
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState(null);
  const [confirmTitle, setConfirmTitle] = useState(null);
  const [file, setFile] = useState(null);
  const [recordingId, setRecordingId] = useState(null);
  const [downloadAll, setDownloadAll] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const dispatch = useDispatch();
  const accessToken = localStorage.getItem("accessToken");
  const meetingData = useSelector((state) => state.meeting);
  const downloadFiles = (files) => {
    files.forEach((file, index) => {
      setTimeout(() => {
        const link = document.createElement("a");
        link.href = file?.download_url;
        link.download = "Recording"; // Optional file name
        link.style.display = "none"; // Hide the link

        document.body.appendChild(link);

        link.click(); // Simulate the click

        // Clean up by removing the link
        document.body.removeChild(link);
      }, index * 1000); // 500 ms  delay between each download
    });
  };

  const downloadSubmit = () => {
    if (downloadAll) {
      downloadFiles(file);
      setDownloadAll(false);
      setFile(null);
      setIsDownloadModalOpen(false);
    } else {
      const files = [file];
      files.forEach((download_url, index) => {
        setTimeout(() => {
          const link = document.createElement("a");
          link.href = download_url;
          link.download = "Recording"; // Optional file name
          link.style.display = "none"; // Hide the link
          link.target = "_blank";
          document.body.appendChild(link);

          link.click(); // Simulate the click

          // Clean up by removing the link
          document.body.removeChild(link);
        }, index * 500); // 500 ms  delay between each download
      });
      setIsDownloadModalOpen(false);
      setFile(null);
    }
  };

  const downloadAllSubmit = (recordingDatas) => {
    const recordingFiles = recordingDatas?.map((rec) => rec?.download_url);
    dispatch(downloadAllZoomRecordings(recordingFiles, accessToken));
  };

  const downloadSingleSubmit = (downloadFile) => {
    const files = [downloadFile];
    files.forEach((download_url, index) => {
      setTimeout(() => {
        const link = document.createElement("a");
        link.href = download_url;
        link.download = "Recording"; // Optional file name
        link.style.display = "none"; // Hide the link
        link.target = "_blank";
        document.body.appendChild(link);

        link.click(); // Simulate the click

        // Clean up by removing the link
        document.body.removeChild(link);
      }, index * 500); // 500 ms  delay between each download
    });
  };

  const handleDeleteSubmit = () => {
    const payload = {
      meetingId: props?.singleMeetingDetails?._id,
      recordingId,
      organizationId: props?.singleMeetingDetails?.organizationId,
    };
    dispatch(deleteZoomRecording(payload, accessToken));

    setIsDeleteModalOpen(false);
  };

  const handleDownloadCloseConfirmModal = () => {
    setIsDownloadModalOpen(false);
    setFile(null);
  };

  const handleDeleteCloseConfirmModal = () => {
    setIsDeleteModalOpen(false);
    setRecordingId(null);
  };

  const handleDeleteConfirmModal = (value, singleRecordingId) => {
    props.handleOpenDeleteModal(singleRecordingId, value);
  };

  return (
    <>
      <Modal
        size="xl"
        show={props.IsViewZoomRecordingModal}
        onHide={(e) => props.setIsViewZoomRecordingModal(false)}
        backdrop="static"
      >
        <div className="modal-header attendees-modal">
          <div className="d-flex justify-content-between w-100 resp-flex-col">
            <h4 className="modal-title">Recordings</h4>

            {!meetingData?.loading ? (
              <button
                className="p-0"
                type="button"
                onClick={() =>
                  downloadAllSubmit(
                    props?.singleMeetingDetails?.recordings?.recordingFile
                  )
                }
              >
                <span className="recording-btn">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="#5f07b0"
                    className="bi bi-cloud-arrow-down-fill me-2"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2m2.354 6.854-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5a.5.5 0 0 1 1 0v3.793l1.146-1.147a.5.5 0 0 1 .708.708" />
                  </svg>

                  {`Download All (${props?.recordingData?.length} ${
                    props?.recordingData?.length > 1 ? "Files" : "File"
                  })`}
                </span>
              </button>
            ) : (
              <button>
                <span className="recording-btn">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="#5f07b0"
                    className="bi bi-cloud-arrow-down-fill me-2"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2m2.354 6.854-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5a.5.5 0 0 1 1 0v3.793l1.146-1.147a.5.5 0 0 1 .708.708" />
                  </svg>
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />{" "}
                  Processing...
                </span>
              </button>
            )}
          </div>

          <div>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={(e) => props.setIsViewZoomRecordingModal(false)}
            ></button>
          </div>
        </div>

        <Modal.Body className="attendees-popup modal-margin">
          <div className="open-div">
            <div className="col-12">
              <div className="alert alert-warning">
                Note: Please download recordings with in 30 days. All recordings
                will be deleted permanently after 30 days.
              </div>
            </div>

            <form className="addminutesboxfrom">
              <div className="">
                <div className="row recording-video-box-wrapper">
                  {props?.recordingData?.length != 0 &&
                    props.recordingData?.map((recording, index) => {
                      return (
                        <div className="col-xl-4 col-lg-4 col-md-6 col-12">
                          <div className="recording-video-box">
                            <div className="video-box">
                              <a
                                id="play-video"
                                className="video-play-button"
                                target="_balnk"
                                href={recording?.play_url}
                              >
                                <span></span>
                              </a>
                            </div>
                            <h2>Session {index + 1}</h2>
                            <span className="video-size">
                              Size: {Math.round(recording?.file_size / 1024)}{" "}
                              kbs ,{" "}
                              {
                                formatDateTimeFormat(recording?.recording_end)
                                  .formattedDate
                              }{" "}
                              {
                                onlyTime(recording?.recording_end)
                                 
                              }
                            </span>
                            <button
                              type="button"
                              className="btn btn-sm download-one me-2 filter-height"
                              onClick={() =>
                                downloadSingleSubmit(recording?.download_url)
                              }
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                fill="#ffffff"
                                className="bi bi-cloud-arrow-down-fill me-2 "
                                viewBox="0 0 16 16"
                              >
                                <path d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2m2.354 6.854-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5a.5.5 0 0 1 1 0v3.793l1.146-1.147a.5.5 0 0 1 .708.708" />
                              </svg>
                              Download
                            </button>
                            <button
                              type="button"
                              className="btn btn-sm delete-one filter-height"
                              onClick={() =>
                                handleDeleteConfirmModal(true, recording?.id)
                              }
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-trash-fill me-2 "
                                viewBox="0 0 16 16"
                              >
                                <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5M8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5m3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0" />
                              </svg>
                              Delete
                            </button>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>

      <ConfirmModal
        message={confirmMessage}
        title={confirmTitle}
        setIsDownloadModalOpen={setIsDownloadModalOpen}
        isDownloadModalOpen={isDownloadModalOpen}
        handleDownloadSubmit={downloadSubmit}
        handleDownloadCloseConfirmModal={handleDownloadCloseConfirmModal}
        buttonName={"Cancel"}
        isCalledFromOthers={true}
        setIsDeleteModalOpen={setIsDeleteModalOpen}
        isDeleteModalOpen={isDeleteModalOpen}
        handleDeleteCloseConfirmModal={handleDeleteCloseConfirmModal}
        handleDeleteSubmit={handleDeleteSubmit}
      />
    </>
  );
});

export default ViewZoomRecordings;
